import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;


if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables!\n\n' +
    'Please create a .env.local file with:\n' +
    'REACT_APP_SUPABASE_URL=your_supabase_project_url\n' +
    'REACT_APP_SUPABASE_ANON_KEY=your_supabase_anon_key\n\n' +
    'Get these from your Supabase project dashboard at https://supabase.com'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types based on our schema
export interface DatabaseMosque {
  id: string;
  name: string;
  type: 'mosque' | 'prayer_room' | 'hired_hall';
  is_public: boolean;
  latitude: number;
  longitude: number;
  address?: string;
  description?: string;
  source_link?: string;
  men_wc: boolean | null;
  women_wc: boolean | null;
  men_wudu: boolean | null;
  women_wudu: boolean | null;
  women_prayer_area: boolean | null;
  status?: 'pending' | 'approved' | 'rejected';
  reviewed_by?: string;
  reviewed_at?: string;
  rejection_reason?: string;
  created_by?: string;
  created_by_name?: string;
  created_at: string;
  updated_at: string;
}

export interface MosqueInsert {
  name: string;
  type: 'mosque' | 'prayer_room' | 'hired_hall';
  is_public: boolean;
  latitude: number;
  longitude: number;
  address?: string;
  description?: string;
  source_link?: string;
  men_wc: boolean | null;
  women_wc: boolean | null;
  men_wudu: boolean | null;
  women_wudu: boolean | null;
  women_prayer_area: boolean | null;
  created_by?: string;
  created_by_name?: string;
  status?: 'pending' | 'approved' | 'rejected';
}

export interface MosqueUpdate {
  name?: string;
  type?: 'mosque' | 'prayer_room' | 'hired_hall';
  is_public?: boolean;
  latitude?: number;
  longitude?: number;
  address?: string;
  description?: string;
  source_link?: string;
  men_wc?: boolean | null;
  women_wc?: boolean | null;
  men_wudu?: boolean | null;
  women_wudu?: boolean | null;
  women_prayer_area?: boolean | null;
}

export interface MosqueSuggestionInsert {
  mosque_id: string;
  suggested_name?: string;
  suggested_type?: 'mosque' | 'prayer_room' | 'hired_hall';
  suggested_is_public?: boolean;
  suggested_latitude?: number;
  suggested_longitude?: number;
  suggested_description?: string;
  suggested_men_wc?: boolean | null;
  suggested_women_wc?: boolean | null;
  suggested_men_wudu?: boolean | null;
  suggested_women_wudu?: boolean | null;
  suggested_women_prayer_area?: boolean | null;
  submitted_by_name?: string;
  reason?: string;
  status?: 'pending' | 'approved' | 'rejected';
}

export interface DatabaseMosquePhoto {
  id: string;
  mosque_id: string;
  storage_path: string;
  file_name: string;
  file_size: number | null;
  mime_type: string | null;
  caption: string | null;
  display_order: number;
  status: 'pending' | 'approved' | 'rejected';
  reviewed_by: string | null;
  reviewed_at: string | null;
  rejection_reason: string | null;
  uploaded_by: string | null;
  created_at: string;
  updated_at: string;
}
